<template>
  <page-wrapper :title="$t('page.error.signuprequest.title')">
    <v-row>
      <v-col md="7">
        <v-card>
          <v-card-title>
            {{ $t('page.error.invalid.signuprequest.section.title') }}
          </v-card-title>
          <v-card-text>
            <div>
              {{ $t('page.error.invalid.signuprequest.section.description') }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </page-wrapper>
</template>

<script>
import PageWrapper from '@components/support/PageWrapper';
import PageMixin from '@/mixins/page';

export default {
  components: { PageWrapper },
  mixins: [ PageMixin ]
};
</script>
